var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1053 14.4909V1.66692C19.1053 1.31342 18.9443 0.977419 18.6689 0.756919C18.3924 0.535252 18.0284 0.451252 17.6854 0.528252L7.21926 2.85342C6.68492 2.97242 6.30459 3.44609 6.30459 3.99209V13.7233C5.79126 13.4899 5.22659 13.3511 4.62576 13.3511C2.37876 13.3511 0.551758 15.1793 0.551758 17.4263C0.551758 19.6721 2.37876 21.5003 4.62576 21.5003C6.87276 21.5003 8.69976 19.6721 8.69976 17.4263C8.69976 17.2174 8.66942 17.0179 8.63792 16.8173V4.92892L16.7719 3.12059V11.3981C16.2586 11.1636 15.6928 11.0259 15.0931 11.0259C12.8461 11.0259 11.0179 12.8529 11.0179 15.0999C11.0179 17.3469 12.8461 19.1739 15.0931 19.1739C17.3389 19.1739 19.1671 17.3469 19.1671 15.0999C19.1671 14.8911 19.1356 14.6916 19.1053 14.4909Z",
    fill: "#7B819B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioFile);
export default __webpack_public_path__ + "static/media/audioFile.39469a6153c8e084df96aee1e015fc6c.svg";
export { ForwardRef as ReactComponent };